import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Location Service
 * Lokasyon bazlı feribot API'leri için servis
 */
export const ferryLocationService = {
  /**
   * Lokasyon içeriğini getir (expandable text için)
   * @param {Object} query - API query
   * @param {string} query.locationId - Lokasyon ID
   * @param {string} query.languageCode - Dil kodu (örn: "tr", "en")
   * @param {string} query.currencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getLocationContent: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.location.getLocationContent}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Lokasyon QA içeriğini getir (FAQ için)
   * @param {Object} query - API query
   * @param {string} query.locationId - Lokasyon ID
   * @param {string} query.languageCode - Dil kodu (örn: "tr", "en")
   * @param {string} query.currencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getLocationQAContent: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.location.getLocationQAContent}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getLocationsByCompanyId: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.location.getLocationsByCompanyId}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),
};
